import React, { useCallback, useState, createContext, useContext } from 'react';
type AnimState = 'idle' | 'expanding' | 'collapsing';
interface ThemeContextType {
  isDark: boolean;
  toggleTheme: (cx: number, cy: number) => void;
  animState: AnimState;
  origin: {
    x: number;
    y: number;
  };
}
const ThemeContext = createContext<ThemeContextType>({
  isDark: false,
  toggleTheme: () => {},
  animState: 'idle',
  origin: {
    x: 50,
    y: 4
  }
});
export function ThemeProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isDark, setIsDark] = useState(false);
  const [animState, setAnimState] = useState<AnimState>('idle');
  const [origin, setOrigin] = useState({
    x: 50,
    y: 4
  });
  const toggleTheme = useCallback((cx: number, cy: number) => {
    if (animState !== 'idle') return;
    setOrigin({
      x: cx,
      y: cy
    });
    const next = !isDark;
    setAnimState(next ? 'expanding' : 'collapsing');
    // Switch theme at ~55% through animation (when char coverage peaks)
    setTimeout(() => setIsDark(next), 660);
    // End animation
    setTimeout(() => setAnimState('idle'), 1200);
  }, [isDark, animState]);
  return <ThemeContext.Provider value={{
    isDark,
    toggleTheme,
    animState,
    origin
  }} data-id="element-225">
      <div className={isDark ? 'theme-dark' : 'theme-light'} style={{
      minHeight: '100vh'
    }} data-id="element-226">
        {children}
      </div>
    </ThemeContext.Provider>;
}
export function useTheme() {
  return useContext(ThemeContext);
}